import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { Question } from '../models/question.model';
import { QuestionSet } from '../models/questionSet.model';
import { AlertController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-question-editor',
  templateUrl: './question-editor.page.html',
  styleUrls: ['./question-editor.page.scss'],
})
export class QuestionEditorPage implements OnInit {
  public questionSet: QuestionSet = {uid: '', name: '', questions: [], owner: ''};

  // tslint:disable-next-line: max-line-length
  constructor(private dataService: DataService, public alertController: AlertController, private router: Router, public authService: AuthenticationService) {
    if (dataService.getSelectedQuestionSet() != null){
      this.questionSet = dataService.getSelectedQuestionSet();
    }
    else{
      this.questionSet.owner = authService.userData.displayName;
    }
  }

  ngOnInit() {
  }

  addQuestion() {
    const question: Question = {prompt: ''};
    this.questionSet.questions.push(question);
  }

  async updateQuestionSet() {
    if (this.dataService.getSelectedQuestionSet() == null){
      if (!await this.dataService.questionSetNameExists(this.questionSet.name)){
        if (this.isValidName(this.questionSet.name)){
          this.questionSet.owner = JSON.parse(localStorage.getItem('user')).uid;
          this.dataService.addQuestionSet(this.questionSet);
          this.router.navigate(['/question-set-editor']);
          this.dataService.setSelectedQuestionSet(null);
        }
      }
      else{
        this.presentAlert();
      }
    }
    else{
      this.dataService.updateQuestionSet(this.questionSet);
      this.router.navigate(['/question-set-editor']);
      this.dataService.setSelectedQuestionSet(null);
    }
  }

  isValidName(name: string) {
    // Other name validation
    return true;
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      message: 'The question set name already exists. Please choose a new one.',
      buttons: ['OK']
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();
  }

  deleteQuestion(question: Question){
    this.questionSet.questions.forEach( (q, index) => {
      if (q === question)
      {
        this.questionSet.questions.splice(index, 1);
      }
    });
  }

  addPlayerToPrompt(question: Question){
    question.prompt += 'PLAYER';
  }
}
